(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gm-hausschuhe-personalization"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',function(event){const form=event.target;const formId=form.getAttribute('id');if(!formId)return;const box=document.querySelector('[data-slipper-personal][data-form="'+CSS.escape(formId)+'"]');if(!box)return;for(const field of box.querySelectorAll('input')){field.value=field.value.trim();if(!field.checkValidity()){event.preventDefault();event.stopImmediatePropagation();field.reportValidity();field.focus();break;}}},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gm-zodiac-personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zodiac-personalization')) {
    customElements.define('zodiac-personalization', class extends HTMLElement {
      connectedCallback() {
        this.dateInput = this.querySelector('[data-personalization-date]');
        this.dateProperty = this.querySelector('[data-personalization-date-property]');
        if (!this.dateInput || !this.dateProperty) return;
        this.dateInput.addEventListener('input', () => this.updateDateProperty());
        this.updateDateProperty();
      }

      updateDateProperty() {
        let formattedDate = '';
        if (this.dateInput.value) {
          const parts = this.dateInput.value.split('-');
          formattedDate = `${parts[2]}.${parts[1]}.${parts[0]}`;
        }
        this.dateProperty.value = formattedDate;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
